var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-warp",on:{"touchmove":_vm.hideMessage}},[_c('div',{staticClass:"message-content"},[_c('div',{staticClass:"message-text"},[_vm._v(_vm._s(_vm.$store.state.messageContent))]),_vm._v(" "),_c('div',{staticClass:"message-btn",on:{"click":_vm.hideMessage}},[_vm._v("OK")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b533272","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LuckDraw/Message.vue
// module id = null
// module chunks = 